import { render, staticRenderFns } from "./Sidebar__formAct.vue?vue&type=template&id=546a8bb3&scoped=true&"
import script from "./Sidebar__formAct.vue?vue&type=script&lang=js&"
export * from "./Sidebar__formAct.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar__formAct.vue?vue&type=style&index=0&id=546a8bb3&scoped=true&lang=css&"
import style1 from "./Sidebar__formAct.vue?vue&type=style&index=1&id=546a8bb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a8bb3",
  null
  
)

export default component.exports